import { Injectable } from '@angular/core';
import { ApplicationService } from '../../utilities/application/application.service';
import { ModalComponent, ModalOptions } from '../../modal/modal.component';
import { FormCoreModule } from '../form-core.module';
import { ModalInstanceService } from './modal-instance.service';
import { ModalServiceStatusComponent } from '../../modal-service-status/modal-service-status.component';

@Injectable({
  providedIn: FormCoreModule
})
export class ModalService {

  private hostView: HTMLBodyElement = document.body as HTMLBodyElement

  constructor(private app: ApplicationService, private modalInstance: ModalInstanceService) { }

  create(options: ModalOptions) {
    this.hostView.style.overflow = 'hidden'
    this.modalInstance.componentRef = options.type === 'modal-all-requirements-component' ? this.app.attach(ModalComponent, this.hostView) : this.app.attach(ModalServiceStatusComponent, this.hostView)
    this.modalInstance.componentRef.instance.content = options.content
    this.modalInstance.componentRef.instance.title = options.title
    this.modalInstance.componentRef.instance.subTitle = options['sub-title']
    this.modalInstance.componentRef.onDestroy(() => this.modalInstance.componentRef = undefined)
  }
}
